<hr>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-plain border-0">
        <div class="card-body">
          <form [formGroup]="form">
            <div class="row">

              <div class="col-md-2">
                <label for="matricula_origem">Cautela de Origem</label>
                <div class="form-group">
                  <input type="text" readonly class="form-control" placeholder="Matricula de origem"
                    id="matricula_origem" formControlName="cD_CDU_MATRICULA_ORIGEM">
                </div>
              </div>
              <div class="col-md-5">
                <label for="nome_origem">Nome de origem</label>
                <div class="form-group">
                  <input type="text" readonly class="form-control text-center" placeholder="Matricula de origem"
                    id="nome_origem" [value]="name">
                </div>
              </div>
              <div class="col-md-4 mx-auto">
                <div class="form-group">
                    <label for="meuBem">Meus Bens</label>
                    
                        <ng-autocomplete 
                        id="meuBem"
                        [data]="cadastro"
                        [searchKeyword]="keywordMeusBens"
                        (selected)='selectMeusBens($event)'
                        [itemTemplate]="itemTemplateMeusBens"
                        [notFoundTemplate]="notFoundTemplateMeusBens"
                        value=""
                        >                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMeusBens let-item>
                      <span [innerHTML]="item.dS_BPM_DESCRICAO_BEM">
                      </span>
                     
                      </ng-template>
                      
                      <ng-template #notFoundTemplateMeusBens let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                    
                
                    </div>
            </div>
              <div class="col-md-4 mx-auto">
                <div class="form-group">
                    <label for="location">Unidade Operacional</label>
                    
                        <ng-autocomplete 
                        id="location"
                        [data]="localizacao"
                        [searchKeyword]="keywordUnidade"
                        (selected)='selectEvent($event)'
                        [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate"
                        >                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.dS_BPM_UNIDADE">
                      </a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                    
                
                    </div>
            </div>
              <div class="col-md-6 mx-auto">
                <div class="form-group">
                    <label for="matricula_destino">Matricula Destino</label>
                    
                        <ng-autocomplete 
                        id="matricula_destino"
                        [data]="data"
                        [searchKeyword]="keywordMatriculaDest"
                        (selected)='selectDest($event)'
                        [itemTemplate]="itemTemplateMatriculaDest"
                        [notFoundTemplate]="notFoundTemplateDest">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMatriculaDest let-item>
                        <a [innerHTML]="item.nome"></a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplateDest let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                    </div>
            </div>
              <div class="col-md-2">
                <label for="sala">Sala</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Sala"
                    id="sala" formControlName="dS_BPM_SALA_POSTERIOR">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck1">
                      <label class="custom-control-label" for="customCheck1">Alienação</label>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-md-12 text-center" *ngIf="loading">
              <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
            </div>
          </div>
        </div>
        <div *ngIf="!loading" class="modal-footer">
          <div class="col-6 text-center mx-auto">
            <button type="button" class="btn btn-success btn-link" (click)="submit()">
              Alterar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>